import CodeMirror from 'codemirror';
import 'codemirror/mode/xml/xml';
import 'froala-editor/js/froala_editor.pkgd.min';

// Loading individual plugins due to a bug on Track Changes https://github.com/froala/wysiwyg-editor/issues/4337#issuecomment-953972677
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/entities.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/help.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/markdown.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/print.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/save.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';

import 'codemirror/lib/codemirror.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';


const ACTIVATION_KEY = '4NC5fB4D3H4C3D3A3C4D-13TMIBDIa2NTMNZFFPFZe2a1Id1f1I1fA8D6C4B4G3H3B1A18A16A2==';
const Group1 = [
  'bold',
  'underline',
  'italic',
  'fontFamily', 'fontSize',
  'textColor',
  'backgroundColor',
  'inlineClass', 'inlineStyle', 
  'strikeThrough',
  'subscript', 'superscript', 
  'clearFormatting'
];
const Group2 = [
  'align',
  'formatUL',
  'paragraphFormat',
  'formatOL',
  'paragraphStyle',
  'outdent',
  'indent',
  'quote'
];
const Group3 = [
  'insertLink',
  'insertImage',
  'insertVideo',
  'insertFile',
  'insertTable',
  'emoticons',
  'specialCharacters',
  'insertHR'
  // 'embedly',
];
const Group4 = [
  'undo',
  'redo',
  'selectAll',
  'fullscreen',
  'html',
  'markdown',
  'print',
  'help'
];

export const baseFroalaConfig = {
  key: ACTIVATION_KEY,
  imageUploadURL: false,
  imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
  imageDefaultWidth: 540,
  imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif', 'webp'],
  fileUploadURL: false,
  fileAllowedTypes: [
    'text/plain',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/webp',
    'application/pdf',
    'application/rtf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'video/quicktime',
    'video/mpeg',
    'audio/mpeg',
    'audio/webm',
    'audio/x-wav'
  ],
  videoUploadURL: false,
  videoMaxSize: 1024 * 1024 * 100, // 100MB
  videoAllowedTypes: ['mp4', 'webm', 'ogg', 'quicktime'],
  codeMirror: CodeMirror,
  fontSize: ['8', '9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '22', '24', '26', '28', '32', '36', '40', '48', '60', '64', '72', '96'],
  fontSizeSelection: true,
  fontSizeDefaultSelection: '16',
  fontFamilyDefaultSelection: 'Arial',
  fontFamily: {
    'Arial,Helvetica,sans-serif': 'Arial',
    'Arial Black,Gadget,sans-serif': 'Arial Black',
    'Comic Sans MS,Comic Sans,sans-serif': 'Comic Sans MS',
    'Courier New,Courier,monospace': 'Courier New',
    'Georgia,serif': 'Georgia',
    'Garamond,serif': 'Garamond',
    'Impact,Charcoal,sans-serif': 'Impact',
    'Lucida Sans Unicode,Lucida Grande,sans-serif': 'Lucida Sans Unicode',
    'Palatino Linotype,Palatino,serif': 'Palatino Linotype',
    'Tahoma,Geneva,sans-serif': 'Tahoma',
    "'Times New Roman',Times,serif": 'Times New Roman',
    'Trebuchet MS,Trebuchet,sans-serif': 'Trebuchet MS',
    'Verdana,Geneva,sans-serif': 'Verdana'
  },
  colorsText: [
   // Row 1: Grays (white to black)
    '#FFFFFF', '#F5F5F5', '#E0E0E0', '#BDBDBD', '#757575', '#424242', '#212121',
    // Row 2: Blues
    '#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#2196F3', '#1565C0', '#0D1A26',
    // Row 3: Greens
    '#F1F8E9', '#C8E6C9', '#A5D6A7', '#81C784', '#388E3C', '#1B5E20', '#0B2F1A',
    // Row 4: Yellows
    '#FFFDE7', '#FFF9C4', '#FFF59D', '#FFE082', '#FFD54F', '#FFB300', '#F57C00',
    // Row 5: Oranges
    '#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D', '#FF9800', '#F57C00', '#E65100',
    // Row 6: Reds
    '#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373', '#F44336', '#D32F2F', '#880E4F',
    // Row 7: Purples
    '#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#8E24AA', '#6A1B9A', '#4A148C',
    // Row 8: additional colors + REMOVE
    '#ECEFF1', '#B0BEC5', '#90A4AE', '#78909C', '#607D8B', '#263238', 'REMOVE'
  ],
  colorsBackground: [
    // Row 1: Grays (white to black)
    '#FFFFFF', '#F5F5F5', '#E0E0E0', '#BDBDBD', '#757575', '#424242', '#212121',
    // Row 2: Blues
    '#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#2196F3', '#1565C0', '#0D1A26',
    // Row 3: Greens
    '#F1F8E9', '#C8E6C9', '#A5D6A7', '#81C784', '#388E3C', '#1B5E20', '#0B2F1A',
    // Row 4: Yellows
    '#FFFDE7', '#FFF9C4', '#FFF59D', '#FFE082', '#FFD54F', '#FFB300', '#F57C00',
    // Row 5: Oranges
    '#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D', '#FF9800', '#F57C00', '#E65100',
    // Row 6: Reds
    '#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373', '#F44336', '#D32F2F', '#880E4F',
    // Row 7: Purples
    '#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#8E24AA', '#6A1B9A', '#4A148C',
    // Row 8: additional colors + REMOVE
    '#ECEFF1', '#B0BEC5', '#90A4AE', '#78909C', '#607D8B', '#263238', 'REMOVE'
  ],
  tableColors: [
   // Row 1: Grays (white to black)
    '#FFFFFF', '#F5F5F5', '#E0E0E0', '#BDBDBD', '#757575', '#424242', '#212121',
    // Row 2: Blues
    '#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#2196F3', '#1565C0', '#0D1A26',
    // Row 3: Greens
    '#F1F8E9', '#C8E6C9', '#A5D6A7', '#81C784', '#388E3C', '#1B5E20', '#0B2F1A',
    // Row 4: Yellows
    '#FFFDE7', '#FFF9C4', '#FFF59D', '#FFE082', '#FFD54F', '#FFB300', '#F57C00',
    // Row 5: Oranges
    '#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D', '#FF9800', '#F57C00', '#E65100',
    // Row 6: Reds
    '#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373', '#F44336', '#D32F2F', '#880E4F',
    // Row 7: Purples
    '#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#8E24AA', '#6A1B9A', '#4A148C',
      // Row 8: additional colors + REMOVE
    '#ECEFF1', '#B0BEC5', '#90A4AE', '#78909C', '#607D8B', '#263238', 'REMOVE'
  ],
  tableCellColors: [
    // Row 1: Grays (white to black)
    '#FFFFFF', '#F5F5F5', '#E0E0E0', '#BDBDBD', '#757575', '#424242', '#212121',
    // Row 2: Blues
    '#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#2196F3', '#1565C0', '#0D1A26',
    // Row 3: Greens
    '#F1F8E9', '#C8E6C9', '#A5D6A7', '#81C784', '#388E3C', '#1B5E20', '#0B2F1A',
    // Row 4: Yellows
    '#FFFDE7', '#FFF9C4', '#FFF59D', '#FFE082', '#FFD54F', '#FFB300', '#F57C00',
    // Row 5: Oranges
    '#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D', '#FF9800', '#F57C00', '#E65100',
    // Row 6: Reds
    '#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373', '#F44336', '#D32F2F', '#880E4F',
    // Row 7: Purples
    '#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#8E24AA', '#6A1B9A', '#4A148C',
    // Row 8: additional colors + REMOVE
    '#ECEFF1', '#B0BEC5', '#90A4AE', '#78909C', '#607D8B', '#263238', 'REMOVE'
  ],
  wordPasteModal: true,
  emoticonsUseImage: false,
  toolbarSticky: false,
  attribution: false, // removes the 'Powered by Froala' tab at the bottom of the Editor
  imageUploadRemoteUrls: false,
  pasteAllowedStyleProps: ['font-size', 'color'],
  pasteDeniedTags: ['input', 'form', 'label'],
  pasteDeniedAttrs: ['class', 'id'],
  iframe: true, // needs to use iframe mode to avoid conflicts with styleguide css,
  pluginsEnabled: [
    'align',
    'charCounter',
    'codeBeautifier',
    'codeView',
    'colors',
    'draggable',
    // 'embedly',
    'emoticons',
    'entities',
    'file',
    'fontFamily',
    'fontSize',
    'fullscreen',
    'help',
    'image',
    'imageManager',
    'inlineClass',
    'inlineStyle',
    'lineBreaker',
    'link',
    'lists',
    'markdown',
    'paragraphFormat',
    'paragraphStyle',
    'print',
    'quote',
    'save',
    'specialCharacters',
    'table',
    'url',
    'video',
    'wordPaste'
  ],
  iframeDefaultStyle:
    'html{margin: 0px;}body{padding:10px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;}body:after{content:"";clear:both;display:block}.fr-view--readmode{padding: 20px;}',
  iframeStyle:
    '.fr-view{font-size: 16px;font-family: Verdana, Geneva, sans-serif;}img.fr-rounded,.fr-img-caption.fr-rounded img{border-radius:10px;-moz-border-radius:10px;-webkit-border-radius:10px;-moz-background-clip:padding;-webkit-background-clip:padding-box;background-clip:padding-box}img.fr-bordered,.fr-img-caption.fr-bordered img{border:solid 5px #CCC}img.fr-bordered{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.fr-img-caption.fr-bordered img{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}img.fr-shadow,.fr-img-caption.fr-shadow img{-webkit-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);-moz-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16)}body{overflow-wrap: break-word;}body span[style~="color:"] a{color: inherit;}body strong{font-weight: 700;}body table{border: medium none; border-collapse: collapse; empty-cells: show; max-width: 100%;}body table td{min-width: 5px;}body table.fr-dashed-borders td, body table.fr-dashed-borders th{border-style: dashed;}body table.fr-alternate-rows tbody tr:nth-child(2n){background: rgb(245, 245, 245) none repeat scroll 0% 0%;}body table td, body table th{border: 1px solid rgb(221, 221, 221);}body table td:empty, body table th:empty{height: 20px;}body table td.fr-highlighted, body table th.fr-highlighted{border: 1px double red;}body table td.fr-thick, body table th.fr-thick{border-width: 2px;}body table th{background: rgb(230, 230, 230) none repeat scroll 0% 0%;}body hr{clear: both; -moz-user-select: none; break-after: page;}body .fr-file{position: relative;}body .fr-file::after{position: relative; content: "📎"; font-weight: normal;}body pre{white-space: pre-wrap; overflow-wrap: break-word; overflow: visible;}body[dir="rtl"] blockquote{border-left: medium none; border-right: 2px solid rgb(94, 53, 177); margin-right: 0px; padding-right: 5px; padding-left: 0px;}body[dir="rtl"] blockquote blockquote{border-color: rgb(0, 188, 212);}body[dir="rtl"] blockquote blockquote blockquote{border-color: rgb(67, 160, 71);}body blockquote{border-left: 2px solid rgb(94, 53, 177); margin-left: 0px; padding-left: 5px; color: rgb(94, 53, 177);}body blockquote blockquote{border-color: rgb(0, 188, 212); color: rgb(0, 188, 212);}body blockquote blockquote blockquote{border-color: rgb(67, 160, 71); color: rgb(67, 160, 71);}body span.fr-emoticon{font-weight: normal; font-family: "Apple Color Emoji", "Segoe UI Emoji", "NotoColorEmoji", "Segoe UI Symbol", "Android Emoji", "EmojiSymbols"; display: inline; line-height: 0;}body span.fr-emoticon.fr-emoticon-img{background-repeat: no-repeat !important; font-size: inherit; height: 1em; width: 1em; min-height: 20px; min-width: 20px; display: inline-block; margin: -0.1em 0.1em 0.1em; line-height: 1; vertical-align: middle;}body .fr-text-gray{color: rgb(170, 170, 170) !important;}body .fr-text-bordered{border-top: 1px solid rgb(34, 34, 34); border-bottom: 1px solid rgb(34, 34, 34); padding: 10px 0px;}body .fr-text-spaced{letter-spacing: 1px;}body .fr-text-uppercase{text-transform: uppercase;}body .fr-class-highlighted{background-color: rgb(255, 255, 0);}body .fr-class-code{border-color: rgb(204, 204, 204); border-radius: 2px; background: rgb(245, 245, 245) none repeat scroll 0% 0%; padding: 10px; font-family: "Courier New", Courier, monospace;}body .fr-class-transparency{opacity: 0.5;}body img{position: relative; max-width: 100%;}body img.fr-dib{margin: 5px auto; display: block; float: none; vertical-align: top;}body img.fr-dib.fr-fil{margin-left: 0px; text-align: left;}body img.fr-dib.fr-fir{margin-right: 0px; text-align: right;}body img.fr-dii{display: inline-block; float: none; vertical-align: bottom; margin-left: 5px; margin-right: 5px; max-width: calc(100% - 10px);}body img.fr-dii.fr-fil{float: left; margin: 5px 5px 5px 0px; max-width: calc(100% - 5px);}body img.fr-dii.fr-fir{float: right; margin: 5px 0px 5px 5px; max-width: calc(100% - 5px);}body span.fr-img-caption{position: relative; max-width: 100%;}body span.fr-img-caption.fr-dib{margin: 5px auto; display: block; float: none; vertical-align: top;}body span.fr-img-caption.fr-dib.fr-fil{margin-left: 0px; text-align: left;}body span.fr-img-caption.fr-dib.fr-fir{margin-right: 0px; text-align: right;}body span.fr-img-caption.fr-dii{display: inline-block; float: none; vertical-align: bottom; margin-left: 5px; margin-right: 5px; max-width: calc(100% - 10px);}body span.fr-img-caption.fr-dii.fr-fil{float: left; margin: 5px 5px 5px 0px; max-width: calc(100% - 5px);}body span.fr-img-caption.fr-dii.fr-fir{float: right; margin: 5px 0px 5px 5px; max-width: calc(100% - 5px);}body .fr-video{text-align: center; position: relative;}body .fr-video.fr-rv{padding-bottom: 56.25%; padding-top: 30px; height: 0px; overflow: hidden;}body .fr-video.fr-rv > iframe, body .fr-video.fr-rv object, body .fr-video.fr-rv embed{position: absolute !important; top: 0px; left: 0px; width: 100%; height: 100%;}body .fr-video > *{box-sizing: content-box; max-width: 100%; border: medium none;}body .fr-video.fr-dvb{display: block; clear: both;}body .fr-video.fr-dvb.fr-fvl{text-align: left;}body .fr-video.fr-dvb.fr-fvr{text-align: right;}body .fr-video.fr-dvi{display: inline-block;}body .fr-video.fr-dvi.fr-fvl{float: left;}body .fr-video.fr-dvi.fr-fvr{float: right;}body a.fr-strong{font-weight: 700;}body a.fr-green{color: green;}body .fr-img-caption{text-align: center;}body .fr-img-caption .fr-img-wrap{padding: 0px; display: inline-block; margin: auto; text-align: center; width: 100%;}body .fr-img-caption .fr-img-wrap img{display: block; margin: auto; width: 100%;}body .fr-img-caption .fr-img-wrap > span{margin: auto; display: block; padding: 5px 5px 10px; font-size: 14px; font-weight: initial; box-sizing: border-box; opacity: 0.9; width: 100%; text-align: center;}body button.fr-rounded, body input.fr-rounded, body textarea.fr-rounded{border-radius: 10px; background-clip: padding-box;}body button.fr-large, body input.fr-large, body textarea.fr-large{font-size: 24px;}body, body:focus{outline: transparent solid 0px;}body{background: transparent none repeat scroll 0% 0%; position: relative; z-index: 2; -moz-user-select: auto;}body a{-moz-user-select: auto;}body.fr-disabled{-moz-user-select: none;}body [contenteditable="true"]{outline: transparent solid 0px;}body img{cursor: pointer;}body table td.fr-selected-cell, body table th.fr-selected-cell{border: 1px double rgb(30, 136, 229);}body table tr{-moz-user-select: none;}body table td, body table th{-moz-user-select: text;}body .fr-no-selection table td, body .fr-no-selection table th{-moz-user-select: none;}body .fr-video{-moz-user-select: none;}body .fr-video::after{position: absolute; content: ""; z-index: 1; top: 0px; left: 0px; right: 0px; bottom: 0px; cursor: pointer; display: block; background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;}body .fr-video.fr-active > *{z-index: 2; position: relative;}body .fr-video > *{box-sizing: content-box; max-width: 100%; border: medium none;}',
  toolbarButtons: {
    moreText: {
      buttons: Group1,
      align: 'left',
      buttonsVisible: 2
    },

    moreParagraph: {
      buttons: Group2,
      align: 'left',
      buttonsVisible: 3
    },

    moreRich: {
      buttons: Group3,
      align: 'left',
      buttonsVisible: 1
    },

    moreMisc: {
      buttons: Group4,
      align: 'left',
      buttonsVisible: 1
    }
  }
};

export const generateConfig = (input) => {
  const {
    richtextEmail, imageUploadToS3, fileUploadToS3, videoUploadToS3,
    height, heightMin, heightMax
  } = input.dataset;
  const useClasses = !richtextEmail;
  const config = {
    ...baseFroalaConfig,
    imageUploadToS3: JSON.parse(imageUploadToS3),
    fileUploadToS3: JSON.parse(fileUploadToS3),
    videoUploadToS3: JSON.parse(videoUploadToS3),
    placeholderText: input.getAttribute('placeholder'),
    useClasses
  };
  // heightMin/heightMax => the editor sizes to its content between those bounds
  // (short content stays compact, long content caps and scrolls). Otherwise fall
  // back to a fixed `height`.
  if (heightMin || heightMax) {
    if (heightMin) config.heightMin = parseInt(heightMin, 10);
    if (heightMax) config.heightMax = parseInt(heightMax, 10);
  } else {
    config.height = height || 300;
  }
  return config;
};
